import { useState } from "react";
import { Mail, ArrowUpRight, CheckCircle2 } from "lucide-react";
import { CONTACT } from "@/data/site";

export default function NewsletterSignup() {
  const [email, setEmail] = useState("");
  const [submitted, setSubmitted] = useState(false);

  const onSubmit = (e) => {
    e.preventDefault();
    if (!email) return;
    const subject = encodeURIComponent("Newsletter signup");
    const body = encodeURIComponent(
      `Please add this email to the AmagicTech newsletter:\n\n${email}\n\nThank you.`
    );
    window.location.href = `mailto:${CONTACT.email}?subject=${subject}&body=${body}`;
    setSubmitted(true);
  };

  if (submitted) {
    return (
      <div
        data-testid="newsletter-success"
        className="border border-zinc-200 p-5 flex items-start gap-3 bg-white"
      >
        <CheckCircle2 className="w-5 h-5 text-emerald-600 mt-0.5 shrink-0" />
        <div>
          <p className="text-zinc-900 text-sm font-medium">Email client opened.</p>
          <p className="text-zinc-600 text-sm mt-1">
            We&apos;ll add you to the list as soon as we receive your message.
          </p>
        </div>
      </div>
    );
  }

  return (
    <form
      onSubmit={onSubmit}
      data-testid="newsletter-form"
      className="border border-zinc-200 p-5 bg-white"
    >
      <p className="label-mono flex items-center gap-2">
        <Mail className="w-3.5 h-3.5" /> Field notes — monthly
      </p>
      <p className="mt-3 text-zinc-700 text-sm leading-relaxed">
        Pragmatic essays on shipping software, AI in production, and
        running a digital studio. One short email a month. No spam.
      </p>
      <div className="mt-4 flex gap-2">
        <input
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder="you@company.com"
          data-testid="newsletter-input"
          className="flex-1 min-w-0 bg-white border border-zinc-300 text-zinc-900 placeholder-zinc-400 px-3 py-2.5 text-sm focus:border-zinc-500 transition-colors"
        />
        <button
          type="submit"
          data-testid="newsletter-submit"
          className="inline-flex items-center gap-1.5 bg-zinc-900 text-white px-4 py-2.5 text-sm font-medium hover:bg-zinc-700 transition-colors"
        >
          Subscribe <ArrowUpRight className="w-3.5 h-3.5" />
        </button>
      </div>
    </form>
  );
}
